var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.578,
  height: 14.063,
  viewBox: "0 0 17.578 14.063"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icon-wallet",
  transform: "translate(5965.719 1075.324)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4447",
  "data-name": "Path 4447",
  d: "M597.184,524.063H586.637A2.64,2.64,0,0,1,584,521.426v-8.789A2.64,2.64,0,0,1,586.637,510h10.547a2.64,2.64,0,0,1,2.637,2.637v1.758a.879.879,0,1,1-1.758,0v-1.758a.88.88,0,0,0-.879-.879H586.637a.88.88,0,0,0-.879.879v8.789a.88.88,0,0,0,.879.879h10.547a.88.88,0,0,0,.879-.879v-1.758a.879.879,0,0,1,1.758,0v1.758A2.64,2.64,0,0,1,597.184,524.063Z",
  transform: "translate(-6549.719 -1585.324)",
  fill: ""
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2933",
  "data-name": "Group 2933",
  transform: "translate(-5956.051 -1071.808)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4448",
  "data-name": "Path 4448",
  d: "M601.152,521.031h-4.395A1.76,1.76,0,0,1,595,519.273v-3.516A1.76,1.76,0,0,1,596.758,514h4.395a1.76,1.76,0,0,1,1.758,1.758v3.516A1.76,1.76,0,0,1,601.152,521.031Zm-4.395-5.273v3.516h4.4v-3.516Z",
  transform: "translate(-595 -514)",
  fill: ""
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2934",
  "data-name": "Group 2934",
  transform: "translate(-5953.414 -1069.171)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4449",
  "data-name": "Path 4449",
  d: "M598.879,518.758a.875.875,0,0,1-.334-.07,1.016,1.016,0,0,1-.29-.185,1.028,1.028,0,0,1-.185-.29.737.737,0,0,1-.07-.334.875.875,0,0,1,.07-.334.909.909,0,0,1,.185-.29,1.017,1.017,0,0,1,.29-.185.836.836,0,0,1,.668,0,1.016,1.016,0,0,1,.29.185.908.908,0,0,1,.185.29.828.828,0,0,1,0,.668,1.027,1.027,0,0,1-.185.29,1.015,1.015,0,0,1-.29.185A.875.875,0,0,1,598.879,518.758Z",
  transform: "translate(-598 -517.001)",
  fill: ""
})))));
export default SvgIconWallet;